export const TitleSkeletonComponent = {
  bindings: {},
  templateUrl: 'components/Skeletons/title-skeleton/title-skeleton.html',
};
